<template>
  <div class="wrapCon">
    <!-- <p>政策详情页面</p> -->
    <div class="def-container">
      <div class="topNav">
        <div class="fs">
          <i class="el-icon-location" style="color: #008ce6"></i>您所在位置：
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="font-size: 16px; display: inline-block"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item
              :to="{ path: '/showPolicy' }"
              v-if="topNavFlag == 10"
              >政策库
            </el-breadcrumb-item>
            <el-breadcrumb-item
              :to="{ path: '/policyService' }"
              v-if="topNavFlag == 1"
              >税惠直达专区</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/showPolicyDetail' }"
              >详情</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>
    </div>
    <div class="def-container detailContainer">
      <div class="leftCon">
        <div class="titleCon">
          <p class="title fb">
            {{ detailData.title || detailData.name||detailData.policyName }}
          </p>
          <div class="subTitle">
            <span>发文字号：{{ detailData.fwzh }}</span>
            <span>发布机构：{{ detailData.fbjg }}</span>
            <span>发布时间：{{ detailData.publictime.substr(0, 10) }}</span>
            <span>浏览量：{{ views }}</span>
          </div>

          <div class="tags" style="width: 100%; text-align: left">
            <!-- 回显后台选的政策标签 -->
            <el-tag
              type="info"
              style="margin: 10px 10px 0 0"
              v-for="item in policyTags.slice(0,14)"
              :key="item.labelname"
              >{{ item.labelname }}
            </el-tag>
            <a v-show="policyTags.length>0&&!showMoreTag"  @click="showMoreTag=!showMoreTag">更多</a>
            <el-tag v-show="showMoreTag"
              type="info"
              style="margin: 10px 10px 0 0"
              v-for="item in policyTags.slice(14)"
              :key="item.labelname"
            >{{ item.labelname }}
            </el-tag>
          </div>
          <div
            style="text-align: right; width: 100%; margin-top: 20px"
            v-show="status"
          >
            <el-radio-group v-model="showType" @change="showEntryOrPolicy">
              <el-radio-button
                v-if="detailData.entrys && detailData.entrys.length > 0"
                label="政策条目"
              ></el-radio-button>
              <el-radio-button label="政策原文"></el-radio-button>
            </el-radio-group>
            <!-- <el-button class="computeBtn" round @click="toPolicyDetail"
                  >查看政策全文</el-button
                > -->
          </div>
        </div>
        <!--<div
          v-show="!flag"
          class="policyContent policyContent2"
          v-html="detailData.content2 || detailData.content"
        ></div>-->
<!--        <div v-show="!flag" >-->
<!--          <div v-if="(aaa != '')" class="ql-editor" v-html="aaa"></div>-->
<!--          <div v-else class="ql-editor" v-html="detailData.content "></div>-->
<!--        </div>-->
        <br />
        <div v-show="!flag" class="ql-editor" v-html="detailData.content2 || detailData.content"></div>
        <div
          v-show="flag"
          v-for="(entry, index) in detailData.entrys"
          :key="index"
        >
          <span class="policyContent policyContent2">
            <div
              style="background: #eff8ff; padding: 5px 10px; font-weight: bold"
            >
              第{{ (index + 1) | smallToBig }}条
            </div>
            <!--<div
              style="
                border: 1px solid #dae7ee;
                padding: 5px 0px 5px 28px;
                border-top: none;
              "
              v-html="entry.entryName"
            ></div>-->
            <div class="ql-editor" v-html="entry.entryName"></div>

          </span>
          <br />
        </div>
      </div>
      <div class="rightCon">
        <div class="guide-btns">
<!--          <el-button-->
<!--            type="primary"-->
<!--            @click="goDeclare"-->
<!--          >项目兑现</el-button>-->
        </div>
        <!-- 发布部门 -->
        <div class="dept">
          <p>
            <img
              src="@/assets/images/showPolicy/star.png"
              alt=""
              style="margin-right: 17px"
            />
            <span style="color: red">发布部门</span>
          </p>
          <div class="middle">
            <img
              src="@/assets/images/showPolicy/2.png"
              width="58"
              height="58"
              alt=""
            />
            <div class="deptName">{{ detailData.deptName }}</div>
          </div>
          <!-- <div class="policyConsult" @click="inputInfo">政策咨询</div> -->
          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="40%"
            v-loading="loading"
          >
            <el-form ref="form" :model="form" label-width="auto" :rules="rules">
              <el-form-item label="企业名称" prop="qyname">
                <el-input v-model="form.qyname"></el-input>
              </el-form-item>
              <el-form-item label="咨询人" prop="person">
                <el-input v-model="form.person"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="form.phone"></el-input>
              </el-form-item>
              <el-form-item label="咨询内容" prop="content">
                <el-input
                  v-model="form.content"
                  type="textarea"
                  style="height: 100px"
                ></el-input>
              </el-form-item>
              <el-form-item
                :span="5"
                style="display: flex; justify-content: space-evenly"
              >
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="dialogVisible = false">返回</el-button>
              </el-form-item>
            </el-form>
            <!-- <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submit"
                >提交</el-button
              >
              <el-button @click="dialogVisible = false">返回</el-button>
            </span> -->
          </el-dialog>
        </div>
        <!-- 相关项目 -->
        <div class="project" v-if="relatedProject.length > 0">
          <p class="title">
            <img
              src="@/assets/images/showPolicy/star.png"
              alt=""
              style="margin-right: 17px"
            />
            <span style="color: red">可兑现项目</span>
          </p>
          <div class="item" v-for="item in relatedProject" :key="item.name">
            <a @click="toProject(item)">{{ item.name }}</a>
            <div>
              <span>{{ item.deptName }}</span>
              <span>{{ item.startTime.split(" ")[0] }}</span>
            </div>
          </div>
        </div>

        <!-- 相关附件 -->
        <div class="project">
          <p class="title">
            <img
              src="@/assets/images/showPolicy/star.png"
              alt=""
              style="margin-right: 17px"
            />
            <span style="color: red">政策附件</span>
          </p>
          <div v-for="item in fileList" :key="item.fileId">
            <span class="downFile" @click="download(item)">
              {{ item.fileName }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="sideNav flexStyle2" v-show="showSideNav">
      <i class="fold" @click="fold"></i>
      <div
        @click="toNewPage('onlineConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-chat-line-round"></i>在线咨询
      </div>
      <div
        @click="toNewPage('phoneConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-phone"></i>电话咨询
      </div>
      <div
        @click="toNewPage('handleConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-s-claim"></i>在线办理
      </div>
      <div
        @click="toNewPage('orderConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-user-solid"></i>预约专家团队咨询
      </div>
      <div
        @click="toNewPage('complaintConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-phone-outline"></i>在线投诉
      </div>
      <div
        @click="toNewPage('onlineJudge')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-chat-line-round"></i>在线评价
      </div>
      <div v-show="!foldFlag" class="foldTxt flexStyle2">快捷功能</div>
    </div>
  </div>
</template>

<script>

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

import { mapGetters } from "vuex";
import { LOGIN_URL, LOGIN_URL_BACK } from "@/store/mutation-types";

export default {
  components: {},
  props: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
  },
  data() {
    return {
      foldFlag: true,
      showSideNav: false, //是否显示侧边栏
      topNavFlag: "", //头部面包屑导航显示
      dialogVisible: false,
      loading: false,
      detailData: {},
      aaa: '',
      showMoreTag:false,// 显示更多的标签
      policyTags: [], //回显政策绑定的标签
      views: "", //浏览量
      form: {
        qyname: "", //企业名称
        person: "", //咨询人
        phone: "", //电话
        content: "", //咨询内容
      },
      rules: {
        qyname: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        person: [
          { required: true, message: "咨询人不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
        ],
        content: [
          { required: true, message: "咨询内容不能为空", trigger: "blur" },
        ],
      },
      relatedProject: [],
      showType: "政策条目",
      flag: true, //控制显示条目内容还是政策原文 默认为条目内容
      status: true, //控制区分政策模拟匹配进入的
      fileList: [],
    };
  },
  created() {
    this.topNavFlag = sessionStorage.getItem("titleType");
    let data = sessionStorage.getItem("policyDetailData");
    this.detailData = JSON.parse(data);
    this.getPolicyById(this.detailData.id || this.detailData.policyId);
    if (sessionStorage.getItem("flag") == "true") {
      this.flag = true;
    } else {
      this.flag = false;
    }
    if (sessionStorage.getItem("status") == "false") {
      this.status = false;
    }
    if (this.detailData.entrys && this.detailData.entrys.length < 1) {
      //如果没有政策条目默认选中政策原文
      this.showType = "政策原文";
      this.flag = false;
    }
    if (this.$route.query.showSideNav) {
      this.showSideNav = this.$route.query.showSideNav;
    }
    //this.getPolicyById(this.detailData.policyId);
    this.projectShow();
    this.queryPolicyLabel();
    this.listFile();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  filters: {
    smallToBig(value) {
      // 汉字的数字
      const cnNums = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      // 基本单位
      const cnIntRadice = ["", "十", "百", "千"];
      // 对应整数部分扩展单位
      const cnIntUnits = ["", "万", "亿", "十亿"];
      // 最大处理的数字
      const maxNum = 9999999999999999.99;
      // 整数部分
      let integerNum;
      // 输出的中文字符串
      let chineseStr = "";
      if (value === "") {
        return "";
      }
      value = parseFloat(value);
      if (value >= maxNum) {
        // 超出最大处理数字
        return "";
      }
      if (value === 0) {
        chineseStr = cnNums[0];
        return chineseStr;
      }
      // 转换为字符串
      value = value.toString();
      integerNum = value;

      // 获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        const IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
          const n = integerNum.substr(i, 1);
          const p = IntLen - i - 1;
          const q = p / 4;
          const m = p % 4;
          if (n === "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            // 归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
      }
      if (chineseStr === "") {
        chineseStr += cnNums[0];
      }
      return chineseStr;
    },
  },
  methods: {
    fold() {
      let navFix = document.querySelector(".sideNav");
      let arrow = document.querySelector(".fold");
      this.foldFlag = !this.foldFlag;
      if (this.foldFlag) {
        navFix.style.background = "red";
        navFix.style.borderColor = "red";
        arrow.style.right = "0%";
        arrow.style.top = "465px";
      } else {
        navFix.style.background = "transparent";
        navFix.style.borderColor = "transparent";
        arrow.style.right = "0%";
        arrow.style.top = "270px";
      }
    },
    handleScroll() {
      let navFix = document.querySelector(".sideNav");
      let sy =
        window.pageYOffset ||
        document.body.scrollTo ||
        document.documentElement.scrollTop;
      navFix.style.position = "fixed";
      navFix.style.top = "200px";
      navFix.style.zIndex = 1000;
    },
    /**
     * @description: 前往政策项目申报(new)
     */
    goDeclare() {
      this.$router.push({
        name: 'policyDeclaration',
        query: {
          policyId: this.relatedProject[0].id,
        },
      })
    },
    toNewPage(param) {
      switch (param) {
        case "orderConsult":
        case "handleConsult":
        case "phoneConsult":
          // this.tabInfo.active = "PolicyConsult";
          this.$router.push("/policyService");
          sessionStorage.setItem("tabInfo_active", "PolicyConsult");
          sessionStorage.setItem("showFlag", param);
          break;
        case "onlineConsult":
          let href = "https://12366.chinatax.gov.cn/xiaohui/";
          window.open(href, "_blank");
          break;
        case "complaintConsult":
          let href2 =
            "https://henan.chinatax.gov.cn/luohe/hdjl/sswfxwjj/wyxx/index.html";
          window.open(href2, "_blank");
          break;
        case "onlineJudge":
          let href3 = "https://www.wjx.cn/vj/tG73KG4.aspx";
          window.open(href3, "_blank");
          break;
        default:
          break;
      }
    },
    /**
     * 展示政策原文还是条目内容
     */
    showEntryOrPolicy(e) {
      if (this.flag) {
        this.flag = false;
      } else {
        this.flag = true;
      }
    },

    // breadcrumbClick(){
    //   switch (this.$route.fullPath) {
    //     case "/showPolicy":
    //        sessionStorage.setItem("titleTypeBack",sessionStorage.getItem("titleType"));
    //        sessionStorage.setItem("titleType", 10);
    //       break;
    //   case "/policyLibrary":
    //        sessionStorage.setItem("titleTypeBack",sessionStorage.getItem("titleType"));
    //        sessionStorage.setItem("titleType", 1);
    //       break;
    //     default:
    //       break;
    //   }
    // },
    toLogin(backurl) {
      // var pathname = window.location.host;
      // if (backurl) {
      //   var url =
      //     LOGIN_URL +
      //     "?refer=cp&backUrl=" +
      //     LOGIN_URL_BACK +
      //     "?targetUrl=" +
      //     pathname +
      //     "/showPolicyDetail";
      // } else {
      //   var url =
      //     LOGIN_URL +
      //     "?refer=cp&backUrl=" +
      //     LOGIN_URL_BACK +
      //     "?targetUrl=" +
      //     pathname;
      // }
      // window.location.href = url;
      this.$router.push({ path: "/login" });
    },
    inputInfo() {
      this.dialogVisible = true;
      // // 已登录
      // if(this.userInfo){
      //   this.dialogVisible = true;
      // }else {
      //   // 未登录
      //   this.toLogin("showPolicyDetail");
      // }
    },
    submit() {
      // this.loading = true;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          await this.addPolicyConsult();
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 新增政策咨询
    addPolicyConsult() {
      let url = "/dev-api/inquiry/info";
      let policyId = this.detailData.id || this.detailData.policyId;
      let consultParams = {
        inquiryCentent: this.form.content,
        inquiryPeople: this.form.person,
        inquiryTel: this.form.phone,
        qymc: this.form.qyname,
        shxydm: this.userInfo.tyshxydm,
        zcid: policyId,
      };
      let that = this;
      that.$httpApi
        .post(url, consultParams)
        .then((res) => {
          // that.loading = false;
          that.$message({
            message: "提交成功",
            type: "success",
          });
        })
        .catch((e) => {});
    },
    //根据政策id查询项目
    projectShow() {
      let policyId = this.detailData.id || this.detailData.policyId;
      let url = "/dev-api/business/sq-apply/selectProjectList";
      let params = {
        policyId: policyId,
        pageSize: 5,
        pageNum: 1,
        serachProject: "",
      };
      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          if (res) {
            that.relatedProject = res.list;
          }
        })
        .catch((e) => {});
    },
    // 根据政策id查询政策绑定的标签
    queryPolicyLabel() {
      let url = "/dev-api/policy-label/queryPolicyLabel";
      let policyId = this.detailData.id || this.detailData.policyId;
      let params = {
        policyId: policyId,
      };
      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          if (res.data) {
            that.policyTags = res.data.labelNamelist;
            that.views = res.data.views;
          }
        })
        .catch((e) => {});
    },

    // 查询业务材料附件列表
    listFile() {
      debugger
      let url = "/dev-api/system/file/fileList";
      if (this.detailData.fileId) {
        this.$httpApi
          .get(url, { fileId: this.detailData.fileId })
          .then((res) => {
            this.fileList = res.rows;
          })
          .catch((e) => {});
      }
    },
    download(val) {
      val.url = val.url.replace("10.50.41.2", "111.6.83.65:8010");
      window.open(val.url + "/download");
    },

    toProject(row) {
      this.$store.commit("updateCurrentGuideId", row.id);
      const { href } = this.$router.resolve({
        path: "/guideSuqiu",
        query: {
          id: row.id,
          // name: item.name,
        },
      });
      window.open(href, "_blank");
    },

    getPolicyById(id){
      let that = this;
      let url = "/dev-api/business/sq-apply/queryPolicyByPolicyId/"+id
      this.$httpApi
        .get(url)
        .then((res) => {
          if(res.code==200){
            that.detailData.content = res.data.content;
            // that.aaa = res.data.content;
          }
        }) .catch((e) => {});
    }
  },
};
</script>

<style lang='scss' scoped>
@import "@/styles/global.scss";

$width: 1200px;
.fb {
  font-weight: bold;
}

.fs {
  font-size: 18px;
}
.flexStyle2 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.wrapCon {
  width: 100%;
  background: #eff8ff;
  //margin-top: -10px;
  position: relative;
  .sideNav {
    width: 100px;
    height: 460px;
    border: 1px solid #1472FF;
    color: #fff;
    background: #1472FF;
    position: absolute;
    right: 5px;
    top: 60px;
    z-index: 1000;
    .fold {
      display: block;
      width:100%;
      height:50px;
      border: 1px solid #1472FF;
      background-color: #1472FF;
      background-image: url("~@/assets/images/fold1.png");
      background-position: center center;
      background-repeat: no-repeat;
      position: absolute;
      right: 0;
      top: 460px;
      font-size: 20px;
      cursor: pointer;
    }
    .foldTxt {
      width: 100px;
      height: 70px;
      margin-right:1px;
      font-size: 18px;
      border-radius: 3px;
      text-align: center;
      background-color: red;
      color:#fff;
    }
    .rotate {
      transform: rotate(180deg);
    }
    div {
      min-height: 50px;
      width: 70px;
      padding: 5px;
      border-radius: 3px;
      font-size: 14px;
      cursor: pointer;
      margin: 7px 0;
      &:hover {
        // color: #ffef69;
        background-color: #ff9000;
      }
      i {
        font-size: 30px;
        display: block;
      }
    }
  }

  .topNav {
    width: 100%;
    height: 52px;
    line-height: 52px;
    display: flex;
    justify-content: flex-start;

    div {
      display: flex;
      align-items: center;
    }
  }
}

.detailContainer {
  // width: $width;
  min-height: 1000px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  border: 1px solid #f4f4f4;
  padding: 30px;
  background-color: #fff;
  // background-color: #eff8ff;
  .leftCon {
    width: 850px;
    min-height: 300px;
    padding-right: 15px;

    .titleCon {
      width: 100%;
      border-bottom: 3px solid #0d1c28;
      text-align: center;
      margin-bottom: 10px;

      .subTitle span {
        font-size: 14px;
        color: #999;
        margin: 10px;
      }

      .tags {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 10px;
        padding-top: 10px;
      }
    }

    .title {
      color: #0d1c28;
      font-size: 28px;
      margin: 10px auto;
    }

    .policyContent {
      font-size: 18px !important;
    }
  }

  .rightCon {
    width: 300px;
    min-height: 300px;

    .dept {
      width: 100%;
      height: 230px;
      // border: 1px solid #eee;
      border-radius: 3px;

      p {
        font-size: 18px;
        // border-bottom: 1px dashed #eee;
        color: #333;
        padding: 16px 0 16px 10px;
      }

      .middle {
        width: 100%;
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .deptName {
          font-size: 16px;
          margin: 10px auto;
        }
      }

      .policyConsult {
        cursor: pointer;
        width: 100px;
        height: 30px;
        margin: 0 auto;
        line-height: 30px;
        text-align: center;
        color: #fff;
        background-color: red;
      }
    }

    .project {
      width: 100%;
      min-height: 300px;
      // border: 1px solid #eee;
      border-radius: 3px;
      margin-top: 20px;

      .title {
        font-size: 18px;
        padding: 16px 0 16px 10px;
        // border-bottom: 1px dashed #eee;
      }

      .item {
        font-size: 16px;
        width: 100%;
        min-height: 100px;
        // border-bottom: 1px solid #eee;
        padding: 10px 0;

        p {
          padding: 0 10px;
          margin-bottom: 10px;
        }

        div {
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
      }
    }

    //  .project:last-child {
    //      border-bottom: none;
    //  }
  }
}

::v-deep {
  .el-input__inner {
    width: 100%;
  }

  .el-button--default,
  .el-button--primary {
    width: 100px !important;
    border-radius: 30px !important;
  }
}

::v-deep .home-container {
  background-color: #eff8ff;
  // background-color: #eee !important;
  margin-top: -5px;
}

.detailContainer .leftCon .titleCon .tags {
  display: block;
}

.changeEntry {
  color: red;
  float: right;
  margin-top: 5px;
  font-size: 16px;
}
.downFile {
  color: #00aff6;
  cursor: pointer;
}
.ql-editor >>> img{
  width: 100%;
}
.ql-editor2 img{
  width: 100% !important;
}
</style>

<style>
.ql-editor img{
  width: 100%;
}
</style>
